import { createSlice } from "@reduxjs/toolkit";

export const modalSlice = createSlice({
  name: "modal",
  initialState: {
    alertModal: {
      status: false,
      type: "",
      message: "",
      header: true,
      btnText: "Continue",
      cancelBtn: false,
      action: null ,
      others: null,

    },

    loader: {
      status: false,
      message: "Please wait, we are processing...",
    },

  },

  reducers: { 
   setAlertModal: (state, { payload }) => {
      state.alertModal = {
        status: payload.status,
        type: payload.type,
        message: payload.message,
        btnText: payload.btnText,
        cancelBtn: payload?.cancelBtn,
        header: payload?.header,
        action: payload?.action,
        others: payload?.others,
      };
    },

    setLoader: (state, { payload }) => {
      state.loader = {
        status: payload.status,
        message: payload.message,
      };
    },
  
  },

});



export const {
  setAlertModal,
  setLoader,
} = modalSlice.actions;
export default modalSlice.reducer;
